import { render, staticRenderFns } from "./ChatIconPrimary.vue?vue&type=template&id=29cb2c54&scoped=true"
import script from "./ChatIconPrimary.vue?vue&type=script&lang=js"
export * from "./ChatIconPrimary.vue?vue&type=script&lang=js"
import style0 from "./ChatIconPrimary.vue?vue&type=style&index=0&id=29cb2c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cb2c54",
  null
  
)

export default component.exports